/**
 * Portfolio Service
 * Handles fetching user position data from Supabase
 */

import { supabase } from '../supabase/supabaseClient';

/**
 * Fetch all positions for a specific wallet address
 * @param {string} walletAddress - User's wallet address
 * @returns {Promise<Array>} Array of position objects
 */
export async function fetchUserPositions(walletAddress) {
  if (!walletAddress) {
    return [];
  }

  try {
    const { data, error } = await supabase
      .from('user_game_positions')
      .select('*')
      .eq('wallet_address', walletAddress)
      .order('updated_at', { ascending: false });

    if (error) {
      console.error('Failed to fetch user positions:', error);
      throw new Error(`Failed to fetch positions: ${error.message}`);
    }

    return data || [];
  } catch (err) {
    console.error('Error in fetchUserPositions:', err);
    throw err;
  }
}
